<template>
  <div
    class="calico-tier-chip"
    :class="tierClass"
  >
    <div class="pair">
      <label class="label--small">Risk Level:</label>
      <div class="label--small">
        <CalicoRiskLevel :risk-level="resolvedRiskLevel" />
      </div>
    </div>

    <span class="divider" />

    <div class="pair">
      <label class="label--small">Data Confidence:</label>
      <div class="label--small">
        <CalicoDataConfidence :data-confidence="resolvedDataConfidence" />
      </div>
    </div>
  </div>
</template>

<script>
import CalicoRiskLevel from '@/components/calico/riskLevel/index.vue'
import CalicoDataConfidence from '@/components/calico/dataConfidence/index.vue'

export default {
  name: 'CalicoTierChip',
  components: { 
    CalicoRiskLevel, 
    CalicoDataConfidence 
  },
  props: {
    tierClass: { 
      type: String, 
      default: '' 
    },
    riskLevel: { 
      type: String, 
      default: '' 
    },
    dataConfidence: { 
      type: String, 
      default: '' 
    },
    score: { 
      type: Object, 
      default: () => ({}) 
    }
  },
  computed: {
    resolvedRiskLevel() {
      const s = this.score || {}
      return this.riskLevel || s.riskLevel || s.title || s.betaScoreRating || '--'
    },
    resolvedDataConfidence() {
      const s = this.score || {}
      return this.dataConfidence || s.dataConfidence || s.confidence || s.betaScoreConfidence || '--'
    },
  }
}
</script>

<style scoped lang="scss">
.calico-tier-chip {
  @include inline-space($space-small);
  border-radius: $radius-round;
  border: 1px solid $color-neutral;
  padding: $space-xxsmall $space-small;
  align-items: center;
  min-height: 22px;

  .pair { 
    @include inline-space($space-small);
    gap: $space-xxsmall; 
  }

  label.label--small { color: $color-neutral; }

  .divider {
    height: 14px;
    border-left: 1px solid $color-neutral;
  }

  &.tier--prime   { color: $color-green; }
  &.tier--growth  { color: $color-cyan; }
  &.tier--emerging{ color: $color-yellow; }
  &.tier--monitor { color: $color-orange; }
  &.tier--caution { color: $color-pink; }
}
</style>
